import * as React from 'react'
import * as Rx from 'rxjs/Rx'
import { Helmet } from 'react-helmet'

import Header from '../Header'
import PhotoModal from '../PhotoModal'
import { APIClient } from '../../io/api-client'
import { Comment } from '../../states/CommentState'
import { Image } from '../../states/WorldState'

export interface Props {
  id: string
}

interface State {
  readonly photo: Image | null
  readonly comments: Array<Comment> | null
}

export default class PhotoPrerender extends React.Component<Props, State> {
  private apiClient = new APIClient(process.env.REACT_APP_API_URL!)
  private subscription = new Rx.Subscription()

  constructor (props: Props, context?: any) {
    super(props, context)
    this.state = {
      photo: null,
      comments: null
    }
  }

  componentDidMount () {
    this.subscription.add(
      this.apiClient.getMapObject(this.props.id).subscribe(mapObject => {
        this.setState({ photo: mapObject as Image })
      })
    )

    this.subscription.add(
      this.apiClient.getPhotoComments(this.props.id).subscribe(comments => {
        this.setState({ comments })
      })
    )
  }

  componentWillUnmount () {
    this.subscription.unsubscribe()
  }

  componentWillUpdate (_: any, nextState: State) {
    if (nextState.comments && nextState.photo) {
      const anyWindow = window as any
      anyWindow.prerenderReady = true
    }
  }

  render () {
    const { photo } = this.state
    if (!photo) {
      return null
    }
    const photoTitle = `TipWander - Photo posted by ${photo.name}`
    const rootURL = process.env.REACT_APP_ROOT_URL!
    const url = `${rootURL}/photo/${this.props.id}`
    return (
      <div>
        <Helmet>
          <title>{photoTitle}</title>
          <meta property='fb:admins' content='100000129030602' />
          <meta property='og:title' content={photoTitle} />
          <meta property='og:site_name' content='TipWander' />
          <meta property='og:url' content={url} />
          <meta property='og:image' content={photo.normalURL} />
          <meta property='og:description' content={photo.note} />
          <meta name='twitter:card' content='photo' />
          <meta name='twitter:site' content='TipWander' />
          <meta name='twitter:title' content={photoTitle} />
          <meta name='twitter:image' content={photo.normalURL} />
          <meta name='twitter:url' content={url} />
        </Helmet>
        <Header
          loginLoading={false}
          loginModal={false}
          loginErrors={{}}
          signUpLoading={false}
          signUpModal={false}
          signUpErrors={{}}
        />
        <PhotoModal
          id={photo.id}
          thumbnail={photo.thumbnailURL}
          photo={photo.normalURL}
          note={photo.note}
          author={photo.name}
          comments={this.state.comments || undefined}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Prerender/PhotoPrerender.tsx